import { render, staticRenderFns } from "./SalesRoleCard.vue?vue&type=template&id=8d9e50ea&scoped=true&"
import script from "./SalesRoleCard.vue?vue&type=script&lang=js&"
export * from "./SalesRoleCard.vue?vue&type=script&lang=js&"
import style0 from "./SalesRoleCard.vue?vue&type=style&index=0&id=8d9e50ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d9e50ea",
  null
  
)

export default component.exports